import { TypedDocumentNode, gql } from '@apollo/client';

import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

import { AveragePlayerScoreCell } from './AveragePlayerScoreCell';
import { BreakdownPlayerScoreCell } from './BreakdownPlayerScoreCell';
import { ProjectionCell } from './ProjectionCell';
import { StatCell } from './StatCell';
import { BenchObjectStatsCells_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: BenchObjectStatsCells_anyPlayer;
};

export const BenchObjectStatsCells = ({ anyPlayer }: Props) => {
  const { statsManager, displayableStats } = useManagePlayerSearchView();

  return (
    <>
      {statsManager[PlayerSearchViewAttributes.AVERAGE_PLAYER_SCORE].map(
        mode => (
          <AveragePlayerScoreCell
            key={mode}
            mode={mode}
            anyPlayer={anyPlayer}
          />
        )
      )}
      {statsManager[PlayerSearchViewAttributes.BREAKDOWN].map(b => (
        <BreakdownPlayerScoreCell key={b} breakdown={b} anyPlayer={anyPlayer} />
      ))}
      {statsManager[PlayerSearchViewAttributes.PROJECTION].map(
        so5FixtureEvent => (
          <ProjectionCell
            key={so5FixtureEvent}
            anyPlayer={anyPlayer}
            so5FixtureEvent={so5FixtureEvent}
          />
        )
      )}
      {displayableStats.map(stat => (
        <StatCell key={stat} stat={stat} anyPlayer={anyPlayer} />
      ))}
    </>
  );
};

BenchObjectStatsCells.fragments = {
  anyPlayer: gql`
    fragment BenchObjectStatsCells_anyPlayer on AnyPlayerInterface {
      slug
      ...AveragePlayerScoreCell_anyPlayer
      ...StatCell_anyPlayer
      ...BreakdownPlayerScoreCell_anyPlayer
      ...ProjectionCell_anyPlayer
    }
    ${AveragePlayerScoreCell.fragments.anyPlayer}
    ${StatCell.fragments.anyPlayer}
    ${BreakdownPlayerScoreCell.fragments.anyPlayer}
    ${ProjectionCell.fragments.anyPlayer}
  ` as TypedDocumentNode<BenchObjectStatsCells_anyPlayer>,
};
